import React, { useEffect, useState } from 'react';
import { 
  Box, Typography, Paper, Avatar, CircularProgress
} from '@mui/material';
import { getCompanie } from '../../../services/companiesService';
import { 
  Business as BusinessIcon,
  Email as EmailIcon, 
  Phone as PhoneIcon, 
  LocationOn as LocationOnIcon
} from '@mui/icons-material';
import { useAuth } from '../../../context/authContext';

const ProfileCard = () => {
  const { user } = useAuth();
  const [profile, setProfile] = useState({
    name: '',
    company: '',
    bio: '',
    email: '',
    phone: '',
    location: '',
    logo: ''
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        setLoading(true);
        const data = await getCompanie(user.business_name, user);
        setProfile({
          name: data.business_name || '',
          company: data.industry || '',
          bio: data.description || '',
          email: data.contact_email || '',
          phone: data.mobile_phone || '',
          location: data.address || '',
          logo: data.logo || '',
          name2:data.trade_name|| ''
        });
      } catch (error) {
        console.error('Error fetching company data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, [user]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Paper elevation={3} sx={{ 
      borderRadius: '12px',
      overflow: 'hidden',
      mb: 3
    }}>
      <Box sx={{ 
        background: 'linear-gradient(to bottom, #09274A, #0488AF)',
        p: 3,
        color: 'white',
        textAlign: 'center'
      }}>
        <Avatar
          sx={{ 
            width: 100, 
            height: 100, 
            mx: 'auto', 
            mb: 2, 
            border: '3px solid white', 
            backgroundColor: 'white' // Fondo blanco detrás del logo
          }}
          src={profile.logo || undefined} // Usamos src para la URL del logo
          alt={profile.name}
        >
          {!profile.logo && profile.name[0]} {/* Respaldo con la inicial del nombre */}
        </Avatar>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {profile.name2}
        </Typography>
        <Typography variant="body2">
          {profile.company}
        </Typography>
      </Box>
      
      <Box sx={{ p: 3 }}>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" sx={{ 
            fontWeight: 600,
            color: '#0488AF',
            mb: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <BusinessIcon fontSize="small" /> Información
          </Typography>
          
         
          
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1, 
            mb: 1 
          }}>
            <EmailIcon fontSize="small" color="action" />
            <Typography variant="body2">
              {profile.email}
            </Typography>
          </Box>
          
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1, 
            mb: 1 
          }}>
            <PhoneIcon fontSize="small" color="action" />
            <Typography variant="body2">
              {profile.phone}
            </Typography>
          </Box>
          
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1 
          }}>
            <LocationOnIcon fontSize="small" color="action" />
            <Typography variant="body2">
              {profile.location}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default ProfileCard;
